<template>
  <div class="first:pt-first-section flex flex-col">
    <div ref="sectionRef">
      <ElementArticleContent :blok="blok" />
    </div>
    <component
      :is="comps[section.component]"
      v-for="section in blok.sections"
      :key="section._uid"
      :blok="section"
    />
  </div>
</template>

<script setup lang="ts">
import { TemplateArticleStoryblok } from '@/types';
import SbSection from '@/components/sb-sections/SbSection.vue';
import useSectionTheme from '@/composables/useSectionTheme';
import { ISbPluginThemeColorPicker } from '@/types';

const comps = {
  Section: SbSection,
};

interface Props {
  blok: TemplateArticleStoryblok;
}
const props = defineProps<Props>();

const sectionRef = ref<HTMLElement | null>(null);
const { observeThemeSection } = useSectionTheme();

const theme = computed(() => {
  const colors = props.blok.backgroundColor as ISbPluginThemeColorPicker;
  return {
    bg: colors.hex,
    text: colors.hexFg,
  };
});

observeThemeSection(sectionRef, theme);

const seo = computed(() => {
  return {
    title: props.blok.title || '',
    description: '',
    image: props.blok.media?.[0]?.image.filename || '',
  };
});
useHead({
  title: seo.value.title,
  meta: [
    { name: 'description', content: seo.value.description },
    { property: 'og:title', content: seo.value.title },
    { property: 'og:description', content: seo.value.description },
    { property: 'og:image', content: seo.value.image },
    { property: 'og:type', content: 'article' },
    { property: 'article:published_time', content: props.blok.date },
    { property: 'article:modified_time', content: props.blok.date },
    { property: 'twitter:title', content: seo.value.title },
    { property: 'twitter:description', content: seo.value.description },
    { property: 'twitter:image', content: seo.value.image },
  ],
});
</script>

<style scoped></style>
